import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Container,
  Form,
  Grid,
  Header,
  Icon,
  Image,
  Message,
  Segment,
} from 'semantic-ui-react';
import XHR from './xhr/xhr.js';
import Free from './Free.js';

class Selector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emotesButtonText: 'Create emotes',
      planningButtonText: 'Create a planning',
      logoButtonText: 'Create a logo',
    };
  }

  clickEmotes = () => {
    if (this.state.emotesButtonText !== 'Coming soon!') {
      XHR.postJson(
        XHR.domain + '/api/interested-by-emotes',
        null,
        {},
      ).then((resp) => {})
    }
    this.setState({
      emotesButtonText: 'Coming soon!',
    });
  }

  clickPlanning = () => {
    if (this.state.planningButtonText !== 'Coming soon!') {
      XHR.postJson(
        XHR.domain + '/api/interested-by-planning',
        null,
        {},
      ).then((resp) => {});
    }
    this.setState({
      planningButtonText: 'Coming soon!',
    });
  }

  clickLogo = () => {
    if (this.state.logoButtonText !== 'Coming soon!') {
      XHR.postJson(
        XHR.domain + '/api/interested-by-logo',
        null,
        {},
      ).then((resp) => {});
    }
    this.setState({
      logoButtonText: 'Coming soon!',
    });
  }

  render() {
    return (
      <Container className="selector">
        <Form>
          <Grid columns={1} stackable>
            <Grid.Column>
              <Header as='h2' textAlign='left'>
                <Icon name='pencil'/>
                <Header.Content>Creation Tool</Header.Content>
                <Header.Subheader>Please select which type of graphics you want to create.</Header.Subheader>
              </Header>
              <Message size='large' positive>
                <Message.Header>Welcome to Stream Maker creation tool!</Message.Header>
                <p>
                If you have any feedback or question, don't hesitate <a target="_blank" href="https://joq0czrvlim.typeform.com/to/sESdVPUQ">to take 15s to fill this form!</a>
                </p>
              </Message>
            </Grid.Column>

            <Grid.Row stretched={true} columns={1}>
              <Grid.Column verticalAlign='middle'>
                <Segment textAlign='center'>
                <Link to="/tool/overlay">
                  <Image floated='left' size='medium' rounded bordered src='/img/overlays/lobby_woody_thumb.jpg' />
                </Link>
                <Link to="/tool/overlay">
                  <Image floated='right' size='medium' rounded bordered src='/img/overlays/angle_thumb.jpg' />
                </Link>
                <Header as='h2'>Overlay</Header>
                  <p style={{fontSize: '1.2em'}}>
                    Few simple steps to easily generate a customised overlay for your stream.
                  </p>
                  <Link to="/tool/overlay">
                  <Button primary size='huge'>
                    <Button.Content>
                      {!Free.ByType["overlay"] &&  <Button.Content> Create an overlay </Button.Content>}
                      {Free.ByType["overlay"] &&  <Button.Content> Create a FREE overlay </Button.Content>}
                    </Button.Content>
                  </Button>
                  </Link>
                </Segment>
              </Grid.Column>
            </Grid.Row>

            {false && <Grid.Row stretched={true} columns={1}>
              <Grid.Column verticalAlign='middle' textAlign='left'>
                <Segment verticalAlign='middle'  textAlign='center'>
                  <Link to="/tool/logo">
                    <Image floated='left' size='small' rounded bordered src='/img/logos/logo1.png' />
                  </Link>
                  <Link to="/tool/logo">
                    <Image floated='right' size='small' rounded bordered src='/img/logos/logo2.png' />
                  </Link>
                  <Header as='h2'>Logo</Header>
                  <p style={{fontSize: '1.2em'}}>
                    Create a logo for your stream in a few clicks.
                  </p>
                  <Link to="/tool/logo">
                  <Button primary size='huge'>
                      {!Free.ByType["logo"] &&  <Button.Content> Create a logo </Button.Content>}
                      {Free.ByType["logo"] &&  <Button.Content> Create a FREE logo </Button.Content>}
                  </Button>
                  <p>
                    Feature in beta.
                  </p>
                  </Link>
                </Segment>
              </Grid.Column>
            </Grid.Row>}

            <Grid.Row stretched={true} columns={1}>
              <Grid.Column verticalAlign='middle' textAlign='left'>
                <Segment textAlign='center'>
                  <Link to="/tool/banner">
                    <Image floated='left' size='medium' rounded bordered src='/img/banners/fire_thumb.jpg' />
                  </Link>
                  <Link to="/tool/banner">
                    <Image floated='right' size='medium' rounded bordered src='/img/banners/split_thumb.jpg' />
                  </Link>
                  <Header as='h2'>Banners</Header>
                  <p style={{fontSize: '1.2em'}}>
                    Some texts, a theme and some colors and your banners will be immediatly generated.
                  </p>
                  <Link to="/tool/banner">
                  <Button primary size='huge'>
                  {!Free.ByType["banner"] &&  <Button.Content> Create a banner </Button.Content>}
                  {Free.ByType["banner"] &&  <Button.Content> Create a FREE banner </Button.Content>}
                  </Button>
                  </Link>
                </Segment>
              </Grid.Column>
            </Grid.Row>


            <Grid.Row stretched={true} columns={1}>
              <Grid.Column verticalAlign='middle' textAlign='left'>
                <Segment textAlign='center'>
                  <Link to="/tool/panel">
                    <Image floated='right' size='medium' rounded bordered src='/img/panels/selector.png' />
                  </Link>
                  <Link to="/tool/panel">
                    <Image floated='left' size='medium' rounded bordered src='/img/panels/selector2.png' />
                  </Link>
                  <Header as='h2'>Panels</Header>
                  <p style={{fontSize: '1.2em'}}>
                    Pretty panels for your stream description or your stream content.
                  </p>
                  <Link to="/tool/panel">
                  <Button primary size='huge'>
                    <Button.Content>
                      {!Free.ByType["panel"] &&  <Button.Content> Create panels </Button.Content>}
                      {Free.ByType["panel"] &&  <Button.Content> Create FREE panels </Button.Content>}
                    </Button.Content>
                  </Button>
                  </Link>
                </Segment>
              </Grid.Column>
            </Grid.Row>

            <Header size='medium'>Coming Soon</Header>

            <Grid.Row stretched={true} columns={1}>
              <Grid.Column verticalAlign='middle' textAlign='left'>
                <Segment textAlign='center'>
                  <Header as='h3'>Planning</Header>
                  <p>
                    Creates your plannings for your subscribers to come on the stream at the right time!
                  </p>
                  <Button size='large' onClick={() => { this.clickPlanning(); }}>
                    {this.state.planningButtonText}
                  </Button>
                </Segment>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row stretched={true} columns={1}>
              <Grid.Column verticalAlign='middle' textAlign='left'>
                <Segment textAlign='center'>
                  <Header as='h3'>Emotes</Header>
                  <p>
                    Funny emotes for a funny stream.
                  </p>
                  <Button size='large' onClick={() => { this.clickEmotes(); }}>
                    {this.state.emotesButtonText}
                  </Button>
                </Segment>
              </Grid.Column>
            </Grid.Row>

          </Grid>
        </Form>
      </Container>
    )
  }
}

export default Selector;



// WEBPACK FOOTER //
// ./src/Selector.js